export default `
uniform vec3 uMouse; // mouse position
uniform float uFriction;
uniform float uRadius;
uniform sampler2D uOriginalPosition; // Const Position

void main() {
    vec2 vUv = gl_FragCoord.xy / resolution.xy;

    vec2 original = texture2D(uOriginalPosition, vUv).xy;
    
    vec2 position = texture2D(uCurrentPosition, vUv).xy;
    vec4 forces = texture2D(uCurrentForces, vUv);

    vec2 speed = forces.xy;
    float gravity = forces.b;
    float maxGravity = forces.a;

    float distanceToMouse = distance(position, uMouse.xy);

    float normalizeFactor = 200.;
    float gravityFactor = 10.;
    vec2 normalized = normalize(position - uMouse.xy) /  normalizeFactor;
    
    if (distanceToMouse < uRadius) {
        gravity *= uFriction;
        speed += normalized;
    } else {
        gravity += 0.1 * (maxGravity - gravity) / gravityFactor;
    }

    vec2 distanceToOriginal = (original - position);

    speed += distanceToOriginal * gravity;

    speed *= uFriction;
    gl_FragColor = vec4(speed, gravity, maxGravity);
}`;
//# sourceMappingURL=simFragmentForces.js.map